import { DeploymentChartType, DeploymentTypeFilter } from "./types";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const DeploymentUsageChartControls = ({
  chartType,
  deploymentTypeFilter,
  onChartTypeChange,
  onDeploymentTypeFilterChange,
}: {
  chartType: DeploymentChartType;
  deploymentTypeFilter: DeploymentTypeFilter;
  onChartTypeChange: (value: DeploymentChartType) => void;
  onDeploymentTypeFilterChange: (value: DeploymentTypeFilter) => void;
}) => (
  <div className="flex shrink-0 items-center justify-end px-6 pb-6">
    <div className="flex flex-wrap items-center justify-end gap-3">
      <div className="flex items-center gap-2">
        <span className="text-xs text-gray-600">Deployment:</span>
        <Select value={deploymentTypeFilter} onValueChange={onDeploymentTypeFilterChange}>
          <SelectTrigger className="h-[30px] w-[140px] px-2 py-1 text-xs">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all" className="text-xs">
              All
            </SelectItem>
            <SelectItem value="public" className="text-xs">
              Public
            </SelectItem>
            <SelectItem value="private" className="text-xs">
              Private
            </SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center gap-2">
        <span className="text-xs text-gray-600">Type:</span>
        <Select value={chartType} onValueChange={onChartTypeChange}>
          <SelectTrigger className="h-[30px] w-[150px] px-2 py-1 text-xs">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="cumulative" className="text-xs">
              Cumulative
            </SelectItem>
            <SelectItem value="periodic" className="text-xs">
              Periodic
            </SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  </div>
);

export default DeploymentUsageChartControls;
